

import {AssertUtils,WinUtils,GoingUtils} from "goingutils";

import {
    _dropSingleCommonHtml,
    _dropCommonHtml,
    _showClearIcon
} from "./Common_Fun";
import EditorTypeUtils from "../../../common/editorTypeUtils";

function __ShowWinDropWin(
    {
        winWidth,
        winHeight,
        winTitle,
        pageUrl,
        backFun,
        param = {},
        showBottomBar = false
    },
    vueObj,
    targetObj
) {
    let submitData = targetObj.getSubmitData();
    //弹出顶层窗口
    WinUtils.showInfoOnWin({
        width: winWidth,
        height: winHeight,
        url: pageUrl,
        showBottomBar: showBottomBar,
        params: GoingUtils.mergeJson(param, submitData),
        title: winTitle,
        anim: null
    });
}

let WinDropCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (item, targetObj) {
        return _dropSingleCommonHtml(
            item,
            targetObj,
            "go-ctl-win",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (item, targetObj) {
        return _dropCommonHtml(item, targetObj, "go-ctl-win", "far fa-file-alt");
    },
    getRealValue(value) {
        return value || " ";
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        //如果不为空的情况下才返回查询的值
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty($("#" + inputElId).val())) {
            backJson[item["id"]] = $("#" + inputElId).val();
        }

        if (AssertUtils.isNotNull(item["treeRelId"])) {
            //设置关联字段的id
            let treeRelId = `${targetObj.prefixCls}_${item["treeRelId"]}`;
            if (AssertUtils.isNotEmpty($("#" + treeRelId).val())) {
                backJson[item["treeRelId"]] = $("#" + treeRelId).val();
            }
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //如果编数据下拉
        backJson[item["id"]] = $("#" + inputElId).val();
        //如果树存在关联字段
        if (AssertUtils.isNotNull(item["treeRelId"])) {
            backJson[item["treeRelId"]] = $(
                `#${targetObj.prefixCls}_${item["treeRelId"]}`
            ).val();
        }
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    initWinObject() {
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        function _initCtlDefEvent(inputId) {
            //点击输入框 弹出下拉选择数据
            $(`#${inputId}`).click(function () {
                let _inputRelId = ($(this)).attr("id").split("_")[1];
                //获取当前定义的字段属性
                let itemObj = (EditorTypeUtils.itemTemp)[inputId];
                __ShowWinDropWin(itemObj, vueObj, targetObj, _inputRelId);
            });

            //点击下拉图标 弹出下拉选择
            $(`#${inputId}_down`).click(function () {
                let _inputRelId = ($(this)).attr("id").split("_")[1];
                //获取当前定义的字段属性
                let itemObj = (EditorTypeUtils.itemTemp)[inputId];
                __ShowWinDropWin(itemObj, vueObj, targetObj, _inputRelId);
            });
        }

        //初始化树控件
        $(parentObj)
            .find(".go-ctl-win")
            .each(function () {
                //如果声明了
                let ctl = $(this).attr("ctl");
                if (ctl === "auto") {
                    let inputId = $(this).attr("id");
                    _initCtlDefEvent(inputId);
                }
            });
    }
};
export default WinDropCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-win-drop.js